// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "49aaa6391831fbcf01a1e786777c6360d515d2a9/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};